import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import StationsContainer from '../containers/Stations';

import Table from '@material-ui/core/Table';
//import TableContainer from '@material-ui/core/TableContainer';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
//import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckIcon from '@material-ui/icons/Check';

import ViewStationDialog from '../components/ViewStationDialog';
import DcStationDialog from '../components/DcStationDialog';
import EnhancedTableHead from '../components/EnhancedTableHead';
import FMPHeadline from '../components/ui/FMPHeadline';
import { isFiltered, sortStationTable, PureRecordRow } from '../libs/utility';
import WarningIcon from '@material-ui/icons/Warning';

import { valueToDisplay } from '../libs/stationRegions';
import { ownershipGroupValueToDisplay } from '../libs/stationOwnershipGroups';

import { getSharedStyles } from '../themes';
import AuthUserContainer from '../containers/AuthUser';
const styles = (theme) => ({
	...getSharedStyles(theme),
	row: {
		cursor: 'pointer',
	},
	warningIcon: {
		marginTop: -9,
		width: 16,
		height: 16,
		position: 'relative',
		bottom: -3,
		marginRight: 1,
		color: '#F4511E',
	},
	button: {
		verticalAlign: 'middle',
		padding: '8px 10px',
	},
	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	dataLabel: {
		textTransform: 'uppercase',
		fontSize: 12,
		paddingRight: 4,
		color: '#999',
	},
	noDataYet: {
		fontStyle: 'italic',
		fontSize: 12,
		paddingRight: 4,
		color: '#999',
	},
});

let columnData = [
	{ id: 'number', numeric: false, label: 'Name' },
	{ id: 'formulaSort', numeric: false, label: 'Formulas' },
	{ id: 'freightCosts', numeric: false, label: 'Freight' },
	{ id: 'regionOwnershipDisplay', numeric: false, label: 'Region/Owner/Carrier' },
	{ id: 'contactInfo', numeric: false, label: 'Contact' },
	{ id: 'statusDisplay', numeric: false, label: 'Status' },
	{ id: 'stationIsNotPublic', numeric: false, label: 'Public' },
	{ id: 'stationIsNotActive', numeric: false, label: 'Active' },
	{ id: 'invoiceQuickbooksCustomerId', numeric: false, label: 'QB' },
	{ id: 'hasSms', numeric: false, label: 'SMS' },
	{
		id: 'edit',
		numeric: false,
		label: 'Modify',
		style: { textAlign: 'center' },
		isNotSortable: true,
	},
];

class Stations extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isViewDialogOpen: false,
			viewStation: {},
			isDcDialogOpen: false,
			dcStation: {},
			order: 'asc',
			orderBy: 'number',
			search: '',
		};
	}

	componentDidMount() {
		if (!this.props.stations.length) {
			this.props.searchStations();
		}
	}

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleEdit = (stationId) => {
		this.props.history.push(`/station/update/${stationId}`);
	};

	handleRowClick = (id) => {
		const { stations } = this.props;
		const viewStation = _.find(stations, { stationId: id });
		this.setState({
			viewStation,
			isViewDialogOpen: true,
		});
	};

	handleDeleteConfirm = (id) => {
		const { stations } = this.props;
		const dcStation = _.find(stations, { stationId: id });
		this.setState({
			dcStation,
			isDcDialogOpen: true,
		});
	};

	handleCloseViewDialog = () => {
		this.setState({ isViewDialogOpen: false });
	};

	handleCloseDcDialog = () => {
		this.setState({ isDcDialogOpen: false });
	};

	handleRequestSort = (property) => {
		const orderBy = property;
		let order = 'desc';
		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	render() {
		const {
			classes,
			stations,
			gasFormulaMap,
			rackFormulaMap,
			biodieselFormulaMap,
			carrierMap = {},
			canMakeUpdates,
			authUser,
			isExternalLogistics,
		} = this.props;

		if (!stations || !gasFormulaMap || !rackFormulaMap || !biodieselFormulaMap || !authUser) {
			return null;
		}
		const { order, orderBy, search } = this.state;

		let selectedId;
		if (this.state.isDcDialogOpen) {
			selectedId = this.state.dcStation.stationId;
		}

		let rows = stations.reduce((result, station) => {
			const {
				stationId,
				name,
				number,
				gasFormulaId,
				rackFormulaId,
				biodieselFormulaId,
				pinnacleDeliveryAdder,
				freightFullLoad,
				//freightHalfLoadSplit,
				//freightHalfLoadNoSplit,
				deliveryEmails,
				invoiceEmails,
				invoiceQuickbooksCustomerId,
				shouldSendSmsPricing,
				stationIsNotPublic,
				stationIsNotActive,
				address,
				region,
				ownershipGroup,
				creditHoldStartDate,
				primaryCarrierId,
			} = station;
			const nameDisplay = `${number} - ${name}`;

			const regionDisplay = valueToDisplay(region);
			const ownershipGroupDisplay = ownershipGroupValueToDisplay(ownershipGroup);

			const gasFormula = gasFormulaMap[gasFormulaId];
			const gasFormulaDisplay = gasFormula ? gasFormula.display : 'Missing e85 formula';

			const rackFormula = rackFormulaMap[rackFormulaId];
			const rackFormulaDisplay = rackFormula ? rackFormula.display : 'Missing rack Formula';

			const biodieselFormula = biodieselFormulaMap[biodieselFormulaId];
			const biodieselFormulaDisplay = biodieselFormula
				? biodieselFormula.display
				: 'Missing biodiesel Formula';

			let freightCosts;
			if (!gasFormulaId && !rackFormulaId && biodieselFormulaId) {
				freightCosts = `n/a`;
			} else if (
				_.isObject(gasFormula) &&
				(gasFormula.formulaKey === 'pinnaclePricing' ||
					gasFormula.formulaKey === 'pinnaclePricingNonContracted')
			) {
				freightCosts = `${pinnacleDeliveryAdder} (delivery adder)`;
			} else {
				//freightCosts = `${freightFullLoad} / ${freightHalfLoadSplit} / ${freightHalfLoadNoSplit}`;
				freightCosts = `${freightFullLoad}`;
			}

			let deliveryEmailList = (
				<div>
					<i style={{ color: '#999' }}>None</i>
				</div>
			);
			if (!_.isEmpty(deliveryEmails)) {
				deliveryEmailList = (
					<div>
						{deliveryEmails.map((email) => {
							return <div key={email}>{email}</div>;
						})}
					</div>
				);
			}

			let invoiceEmailList = (
				<div>
					<i style={{ color: '#999' }}>None</i>
				</div>
			);
			if (!_.isEmpty(invoiceEmails)) {
				invoiceEmailList = (
					<div>
						{invoiceEmails.map((email) => {
							return <div key={email}>{email}</div>;
						})}
					</div>
				);
			}

			const isQuickbooksLinked = invoiceQuickbooksCustomerId ? <CheckIcon /> : <div />;
			const hasSms = shouldSendSmsPricing ? <CheckIcon /> : <div />;

			const isPublic = !stationIsNotPublic ? <CheckIcon /> : <div />;
			const isActive = !stationIsNotActive ? <CheckIcon /> : <div />;

			let formulaDisplay = (
				<Fragment>
					{gasFormulaId !== 0 && (
						<div>
							<span className={classes.dataLabel}>E85:</span>
							<span>{gasFormulaDisplay}</span>
						</div>
					)}
					{rackFormulaId !== 0 && (
						<div>
							<span className={classes.dataLabel}>RACK:</span>
							<span>{rackFormulaDisplay}</span>
						</div>
					)}

					{biodieselFormulaId !== 0 && (
						<div>
							<span className={classes.dataLabel}>BD:</span>
							<span>{biodieselFormulaDisplay}</span>
						</div>
					)}
				</Fragment>
			);

			if (gasFormulaId === 0 && rackFormulaId === 0 && biodieselFormulaId === 0) {
				formulaDisplay = <span className={classes.noDataYet}>No formula</span>;
			}

			const { contactName, contactPhoneNumber, openOrComingSoon } = station;
			let contactInfo = (
				<div>
					<div>{contactName}</div>
					<div>{contactPhoneNumber}</div>
				</div>
			);

			const components = address.split(',');
			const addressDisplay = (
				<div>
					<div>{components.shift()}</div>
					<div>{components.join(',')}</div>
				</div>
			);

			let primaryCarrierDisplay = null;
			if (primaryCarrierId) {
				const carrier = carrierMap[primaryCarrierId] || { name: 'Missing' };
				primaryCarrierDisplay = (
					<>
						<br />
						{carrier.name}
					</>
				);
			}

			const openOrComingSoonMap = { open: 'Open', comingSoon: 'Coming Soon' };

			let statusDisplay = openOrComingSoonMap[openOrComingSoon];
			if (creditHoldStartDate) {
				statusDisplay = (
					<div>
						<div>{openOrComingSoonMap[openOrComingSoon]}</div>
						<div
							style={{
								whiteSpace: 'nowrap',
								fontSize: '90%',
								fontWeight: 'bold',
								marginTop: 3,
								color: '#222',
							}}
						>
							<WarningIcon className={classes.warningIcon} /> CREDIT HOLD
						</div>
					</div>
				);
			}

			const row = {
				stationId,
				number,
				nameDisplay,
				formulaDisplay,
				formulaSort: gasFormulaDisplay + rackFormulaDisplay + biodieselFormulaDisplay,
				isSelected: stationId === selectedId,
				freightCosts,
				deliveryEmailList,
				invoiceEmailList,
				contactInfo,
				statusDisplay,
				isPublic,
				isActive,
				stationIsNotPublic,
				stationIsNotActive,
				isQuickbooksLinked,
				invoiceQuickbooksCustomerId,
				hasSms,
				addressDisplay,
				regionDisplay,
				ownershipGroupDisplay,
				regionOwnershipDisplay: (
					<>
						{regionDisplay}
						<br />
						{ownershipGroupDisplay}
						{primaryCarrierDisplay}
					</>
				),
				click: () => {
					this.handleRowClick(stationId);
				},
			};

			if (
				isFiltered({
					search,
					data: row,
					fields: ['nameDisplay', 'regionDisplay', 'ownershipGroupDisplay'],
				})
			) {
				return result;
			}

			result.push(row);
			return result;
		}, []);

		rows = sortStationTable({ rows, order, orderBy });

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<FMPHeadline
						label="Stations"
						value={this.state.search}
						onChange={this.handleSearch}
						buttonText="ADD STATION"
						url="/station/add"
						canMakeUpdates={isExternalLogistics ? false : canMakeUpdates}
					/>

					<Paper className={classes.paper}>
						{!isExternalLogistics && this.renderTableForEmployees(rows)}
						{isExternalLogistics && this.renderTableForExternalLogistics(rows)}

						<ViewStationDialog
							onClose={this.handleCloseViewDialog}
							rackFormulaMap={rackFormulaMap}
							gasFormulaMap={gasFormulaMap}
							authUser={authUser}
							station={this.state.viewStation}
							open={this.state.isViewDialogOpen}
							history={this.props.history}
						/>

						<DcStationDialog
							onClose={this.handleCloseDcDialog}
							station={this.state.dcStation}
							open={this.state.isDcDialogOpen}
							history={this.props.history}
							removeStation={this.props.removeStation}
						/>
					</Paper>
				</Grid>
			</Grid>
		);
	}

	renderTableForEmployees = (rows) => {
		const { classes, canMakeUpdates } = this.props;
		const { order, orderBy } = this.state;

		return (
			<Table stickyHeader size="small" className={classes.table}>
				<EnhancedTableHead
					columnData={columnData}
					order={order}
					orderBy={orderBy}
					onRequestSort={this.handleRequestSort}
				/>
				<TableBody>
					{rows.map((row) => {
						return (
							<PureRecordRow
								hover
								className={classes.row}
								style={{ backgroundColor: row.isSelected ? '#ef9a9a' : undefined }}
								key={row.stationId}
							>
								<TableCell onClick={row.click}>{row.nameDisplay}</TableCell>
								<TableCell onClick={row.click}>{row.formulaDisplay}</TableCell>
								<TableCell onClick={row.click}>{row.freightCosts}</TableCell>
								<TableCell onClick={row.click}>{row.regionOwnershipDisplay}</TableCell>
								<TableCell onClick={row.click}>{row.contactInfo}</TableCell>
								<TableCell onClick={row.click}>{row.statusDisplay}</TableCell>
								<TableCell onClick={row.click}>{row.isPublic}</TableCell>
								<TableCell onClick={row.click}>{row.isActive}</TableCell>
								<TableCell onClick={row.click}>{row.isQuickbooksLinked}</TableCell>
								<TableCell onClick={row.click}>{row.hasSms}</TableCell>

								{canMakeUpdates && (
									<TableCell style={{ whiteSpace: 'nowrap' }}>
										<Button
											className={classes.button}
											onClick={() => this.handleEdit(row.stationId)}
										>
											Edit
										</Button>
										<IconButton
											className={classes.button}
											onClick={() => this.handleDeleteConfirm(row.stationId)}
										>
											<DeleteIcon />
										</IconButton>
									</TableCell>
								)}
							</PureRecordRow>
						);
					})}
				</TableBody>
			</Table>
		);
	};

	renderTableForExternalLogistics = (rows) => {
		const { classes, canMakeUpdates } = this.props;
		const { order, orderBy } = this.state;

		let columnData = [
			{ id: 'number', numeric: false, label: 'Name' },
			{ id: 'addressDisplay', numeric: false, label: 'Address' },
			{ id: 'contactInfo', numeric: false, label: 'Contact' },
			{ id: 'statusDisplay', numeric: false, label: 'Status' },
			{ id: 'stationIsNotPublic', numeric: false, label: 'Is Public' },
			{ id: 'stationIsNotActive', numeric: false, label: 'Is Active' },
			{
				id: 'view',
				numeric: false,
				label: 'View',
				style: { textAlign: 'center' },
				isNotSortable: true,
			},
		];

		return (
			<Table stickyHeader size="small" className={classes.table}>
				<EnhancedTableHead
					columnData={columnData}
					order={order}
					orderBy={orderBy}
					onRequestSort={this.handleRequestSort}
				/>
				<TableBody>
					{rows.map((row) => {
						return (
							<PureRecordRow
								hover
								className={classes.row}
								style={{ backgroundColor: row.isSelected ? '#ef9a9a' : undefined }}
								key={row.stationId}
							>
								<TableCell onClick={row.click}>{row.nameDisplay}</TableCell>
								<TableCell onClick={row.click}>{row.addressDisplay}</TableCell>
								<TableCell onClick={row.click}>{row.contactInfo}</TableCell>
								<TableCell onClick={row.click}>{row.statusDisplay}</TableCell>
								<TableCell onClick={row.click}>{row.isPublic}</TableCell>
								<TableCell onClick={row.click}>{row.isActive}</TableCell>

								{canMakeUpdates && (
									<TableCell style={{ whiteSpace: 'nowrap' }}>
										<Button
											className={classes.button}
											onClick={() => this.handleEdit(row.stationId)}
										>
											View
										</Button>
									</TableCell>
								)}
							</PureRecordRow>
						);
					})}
				</TableBody>
			</Table>
		);
	};
}

Stations.propTypes = {
	classes: PropTypes.object.isRequired,
	searchStations: PropTypes.func.isRequired,
	removeStation: PropTypes.func.isRequired,
	stations: PropTypes.array,
	rackFormulaMap: PropTypes.object,
	gasFormulaMap: PropTypes.object,
	carrierMap: PropTypes.object,
	biodieselFormulaMap: PropTypes.object,
	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	canMakeUpdates: PropTypes.bool,
	authUser: PropTypes.object,
	isExternalLogistics: PropTypes.bool.isRequired,
};

export default _.flow([withStyles(styles), StationsContainer, AuthUserContainer])(Stations);
